import api from "./api";

export const listAdminUsers = async (query = {}) => {
  const { data } = await api.get("/admin/v1/users", { params: query });
  return data;
};

export const showAdminUser = async (id) => {
  const { data } = await api.get(`/admin/v1/users/${id}`);
  return data;
};

export const createAdminUser = async (payload) => {
  const { data } = await api.post("/admin/v1/users", payload);
  return data;
};

export const updateAdminUser = async (id, payload) => {
  const { data } = await api.patch(`/admin/v1/users/${id}`, payload);
  return data;
};

export const updateUserSuper = async (id, superValue) => {
  const { data } = await api.patch(`/admin/v1/users/${id}/super`, { super: superValue });
  return data;
};

export const listAllCompanies = async () => {
  const { data } = await api.get("/admin/v1/announcements/companies");
  return data;
};

export const updateUserAccountStatus = async (userId, accountStatus) => {
  const { data } = await api.patch(`/admin/v1/users/${userId}/status`, { accountStatus });
  return data;
};
